import React from 'react';
import {ProjectPreviewMode} from '@taopix/taopix-core';
import PageTurningPreview, {PageTurningPreviewProps} from './PageTurningPreview';
import ListPreview from './ListPreview';

export type PreviewFactoryProps = PageTurningPreviewProps & {
  classNames: string;
  mode: ProjectPreviewMode;
  isSmallScreen: boolean;
};
const PreviewFactory = (props: PreviewFactoryProps) => {
  if (props.isSmallScreen) {
    return <ListPreview {...props} />;
  }

  switch (props.mode) {
    case ProjectPreviewMode.Flip:
      return <PageTurningPreview {...props} />;
    case ProjectPreviewMode.List:
      return <ListPreview {...props} />;
  }
};

export default PreviewFactory;
